// extracted by mini-css-extract-plugin
export var card = "_jx-5";
export var cardSelected = "_jx-4";
export var image = "_jx-3";
export var modal = "_jx-0";
export var modalContent = "_jx-1";
export var table = "_jx-2";